var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header'),_c('Calendar',{attrs:{"language":"pt","id":"calendar","data-source":_vm.getDataSource},on:{"mouse-on-day":_vm.mouseOnDay}}),_c('Legends')],1)}
var staticRenderFns = []

export { render, staticRenderFns }